import { createFileRoute, redirect } from '@tanstack/react-router';

// The Goals / maturity page moved into the Setup section as the purple "Strategy" tab (#6011).
// This route is kept only as a redirect so existing /strategy deep links land on the tab.
export const Route = createFileRoute('/_authenticated/_layout/strategy/')({
  beforeLoad: () => {
    throw redirect({ to: '/setup', hash: 'strategy' });
  },
});
